import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { LoggedOutAutocompleteInputProps } from './autocomplete-input-location';

export const useAutocompleteInput = <P>({
  onChange: onChangeProps,
  initialValue,
}: LoggedOutAutocompleteInputProps<P>) => {
  const [value, setValue] = useState('');
  const [showSearchResults, setShowSearchResults] = useState(false);

  useEffect(() => {
    if (initialValue) setValue(initialValue);
  }, [initialValue]);

  const resetSupplier = useCallback(() => {
    onChangeProps?.(null);
  }, [onChangeProps]);

  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value || '';
      setShowSearchResults(true);
      setValue(value);
      if (value === '') resetSupplier();
    },
    [resetSupplier],
  );

  const onClick = useCallback(
    (value: string, option: P) => {
      setValue(value);
      setShowSearchResults(false);
      onChangeProps?.(option);
    },
    [onChangeProps],
  );

  const onFocus = useCallback(() => {
    setValue('');
    onChangeProps?.(null);
  }, [onChangeProps]);

  const onEscape = useCallback(() => {
    setShowSearchResults(false);
  }, []);

  const onBlur = useCallback(() => {
    // prevent blur event to be fired before click event, otherwise it would be impossible to click the result
    const waitForClickTime = 150;
    setTimeout(() => {
      setShowSearchResults(false);
    }, waitForClickTime);
  }, []);

  return {
    onBlur,
    onEscape,
    onFocus,
    onClick,
    onChange,
    value,
    showSearchResults,
  };
};
